import { render, staticRenderFns } from "./CardNovidadeCustom.vue?vue&type=template&id=38173680&scoped=true"
import script from "./CardNovidadeCustom.vue?vue&type=script&lang=js"
export * from "./CardNovidadeCustom.vue?vue&type=script&lang=js"
import style0 from "./CardNovidadeCustom.vue?vue&type=style&index=0&id=38173680&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38173680",
  null
  
)

export default component.exports